import { memo } from 'react';
import classnames from 'clsx';
import { TabPanel as ReactTabsTabPanel } from 'react-tabs';

import style from './tab-panel.module.css';

import type { TabPanelProps } from 'react-tabs';
import type { ReactTabsMemoComponent } from 'ui-components/components/tabs/tabs-types';

export const TabPanel: ReactTabsMemoComponent<TabPanelProps> = memo(({ children, selectedClassName, ...rest }) => (
  <ReactTabsTabPanel
    className={style['tab-panel']}
    selectedClassName={classnames(style['selected-tab-panel'], selectedClassName)}
    {...rest}
  >
    {children}
  </ReactTabsTabPanel>
));

TabPanel.displayName = 'TabPanel';
TabPanel.tabsRole = 'TabPanel';
